<template>
  <action-dispatcher
    action="workout/getGoals"
    class="workout-profile-dialog text-center p-4"
  >
    <h3 class="d-flex align-items-center justify-content-center mb-3">
      <img src="@/assets/images/workout/icon.svg" class="mr-3" /> Seja Forte
    </h3>

    <div class="mb-2">
      <span class="text-warning">{{ step }}</span
      >/6
    </div>

    <form @submit.prevent="next">
      <div v-if="step === 1">
        <h3>Nos fale sobre você</h3>
        <p>
          Essa informação é importante para que você tenha uma experiência
          personalizada com o noso conteúdo.
        </p>

        <div
          class="d-flex align-items-center justify-content-center mx-n3 py-3"
        >
          <button
            type="button"
            class="btn-gender mx-3"
            :class="{ active: form.gender === 'm' }"
            @click="form.gender = 'm'"
          >
            <i class="fas fa-mars"></i>
            Masculino
          </button>
          <button
            type="button"
            class="btn-gender mx-3"
            :class="{ active: form.gender === 'f' }"
            @click="form.gender = 'f'"
          >
            <i class="fas fa-venus"></i>
            Feminino
          </button>
        </div>
      </div>

      <div v-if="step === 2">
        <h3>Qual a sua idade?</h3>
        <div class="d-flex align-items-center justify-content-center">
          <form-group
            v-model="form.age"
            id="form-age"
            mask="###"
            class="mb-0"
            placeholder="0"
          />
          <span class="ml-3">Anos</span>
        </div>
      </div>

      <div v-if="step === 3">
        <h3>Qual a sua altura</h3>
        <div class="d-flex align-items-center justify-content-center">
          <form-group
            v-model="form.height"
            id="form-height"
            mask="#,##"
            class="mb-0"
            placeholder="0"
          />
          <span class="ml-3">m</span>
        </div>
      </div>

      <div v-if="step === 4">
        <h3>Qual o seu peso?</h3>
        <div class="d-flex align-items-center justify-content-center">
          <form-group
            v-model="form.weight"
            id="form-weight"
            mask="###"
            class="mb-0"
            placeholder="0"
          />
          <span class="ml-3">kg</span>
        </div>
      </div>

      <div v-if="step === 5">
        <h3>Qual o seu nível de condicionamento</h3>
        <div class="row justify-content-center pb-3">
          <div class="col-lg-8">
            <vue-slider
              v-model="form.number_workouts_week"
              :data="['Iniciante', 'Intermediário', 'Avançado']"
              tooltip="none"
              adsorb
              marks
            />
          </div>
        </div>
      </div>

      <div v-if="step === 6">
        <h3>Quais os seus 3 objetivos principais?</h3>

        <button
          v-for="(object, index) in this.form.objects"
          :key="object"
          type="button"
          class="btn btn-object"
          @click="removeGoal(object)"
        >
          <span class="mr-2">{{ index + 1 }}º</span>
          <span class="flex-fill">{{ object }}</span>
          <i class="fas fa-times"></i>
        </button>

        <div class="mb-4"></div>

        <template v-for="goal in goals">
          <button
            v-if="!form.objects.includes(goal.name)"
            class="btn btn-goal"
            :key="goal.id"
            type="button"
            @click="addGoal(goal)"
          >
            {{ goal.name }}
          </button>
        </template>
      </div>

      <div class="row justify-content-center mt-5">
        <div v-if="step > 1" class="col-lg-6 py-2">
          <button
            type="button"
            class="btn btn-outline-light btn-strong w-100 rounded-pill"
            @click="back"
          >
            VOLTAR
          </button>
        </div>
        <div class="col-lg-6 py-2">
          <button
            type="submit"
            class="btn btn-strong w-100 rounded-pill"
            :class="{
              'btn-secondary': nextDisabled,
              'btn-warning': !nextDisabled
            }"
            :disabled="nextDisabled"
          >
            <loading :show="loading">
              PRÓXIMO
            </loading>
          </button>
        </div>
      </div>
    </form>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import { formFields } from "@/functions/helpers.js";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  components: { VueSlider },
  data() {
    return {
      step: 1,
      ...formFields(
        [
          "gender",
          "age",
          "height",
          "weight",
          "objects",
          "number_workouts_week"
        ],
        {
          objects: [],
          number_workouts_week: "Iniciante"
        }
      )
    };
  },
  computed: {
    ...mapState("workout", ["goals"]),
    nextDisabled() {
      switch (this.step) {
        case 1:
          return !this.form.gender;
        case 2:
          return !this.form.age;
        case 3:
          return !this.form.height;
        case 4:
          return !this.form.weight;
        case 5:
          return !this.form.gender;
        case 6:
          return this.form.objects.length < 3;
      }
      return false;
    }
  },
  methods: {
    back() {
      if (this.step <= 1) {
        this.$emit("close");
      } else {
        this.step--;
      }
    },
    next() {
      if (this.nextDisabled) return;
      if (this.step < 6) {
        this.step++;
      } else {
        this.loading = true;
        const data = {
          ...this.form,
          height: this.form.height.padEnd(3, "0"),
          number_workouts_week: { Iniciante: 0, Intermediário: 1, Avançado: 2 }[
            this.form.number_workouts_week
          ]
        };
        this.$store
          .dispatch("user/updatePerfil", data)
          .then(() => {
            this.$message.success("Perfil salvo com sucesso");
            this.$emit("close");
          })
          .catch(() => {
            this.$message.error("Erro");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    addGoal(goal) {
      if (this.form.objects.length < 3) {
        this.form.objects.push(goal.name);
      }
    },
    removeGoal(goal) {
      this.form.objects.splice(this.form.objects.indexOf(goal), 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.workout-profile-dialog {
  h3 {
    margin-bottom: 24px;
  }

  .btn-gender {
    background: rgba(0, 0, 0, 0.5);
    color: white;
    font-weight: 400;
    font-size: 10px;
    line-height: 150%;
    width: 108px;
    height: 108px;
    border-radius: 108px;
    border: none;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    i {
      color: #ff622c;
      margin-bottom: 12px;
      font-size: 40px;
    }

    &.active {
      background: #ff622c;

      i {
        color: white;
      }
    }
  }

  ::v-deep .form-control {
    font-weight: 500;
    font-size: 40px;
    line-height: 28px;
    width: 120px;
    text-align: center;
  }

  ::v-deep .vue-slider {
    .vue-slider-rail {
      background: rgba(0, 0, 0, 0.5);
    }

    .vue-slider-process {
      background: #ff622c;
    }

    .vue-slider-dot {
      width: 20px !important;
      height: 20px !important;

      .vue-slider-dot-handle {
        background: #ff622c;
        box-shadow: -5px 4px 4px rgba(0, 0, 0, 0.65);
        width: 20px;
        height: 20px;
        border: none;
      }
    }
  }

  .btn-goal {
    background: rgba(0, 0, 0, 0.5);
    color: #eee;
    border-radius: 100px;
    margin: 4px 8px;
    font-weight: bold;
    font-size: 14px;
    padding: 12px 15px;
  }

  .btn-object {
    background: #ed4a24;
    border-radius: 5px;
    color: #eeeeee;
    padding: 14px 16px;
    width: 100%;
    font-weight: bold;
    text-align: left;
    margin-bottom: 4px;
    display: flex;
    align-items: center;

    &:nth-of-type(1) {
      background: #ed4a24;
    }
    &:nth-of-type(2) {
      background: #cf3511;
    }
    &:nth-of-type(3) {
      background: #a0290d;
    }
  }
}
</style>
